var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-component"},[_c('VueSlider',{style:({
      width: '100%',
      padding: '0px',
    }),attrs:{"lazy":true,"max":_vm.totalTime,"disabled":_vm.disabled,"tooltip-formatter":_vm.tooltipFormatter,"process-style":{
      backgroundColor: '#28e270',
      height: '1em',
      'border-radius': '0px',
    },"tooltip-style":{
      backgroundColor: '#116230',
      borderColor: '#116230',
    },"railStyle":{
      height: '1em',
      'border-radius': '0px',
    }},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }